/* eslint-disable */
import React, { useState, useEffect } from 'react';
// material-ui
import { useTheme } from '@mui/material/styles';
import { URL_API_UPLOADS } from 'config';

import logoDark from 'assets/images/logos/logo_admin_farpro_V2.png';
import logo from 'assets/images/logos/logo_admin_farpro_V2.png';
import tuLogoAqui from 'assets/images/logos/logo_tu_logo_aqui.png';
import useAuth from 'hooks/useAuth';
// ==============================|| LOGO SVG ||============================== //

const LogoAdminFarPro = () => {
    const { company } = useAuth();
    const [smallLogo,setSmallLogo]=useState("");
    const theme = useTheme();


    useEffect(()=>{
        if ((company!== null)&&(company!== undefined)){
            setSmallLogo(company.small_logo);
        }
    },[]);
    return (
        <div>
            { (company !== undefined) && (company !== null) ?
                <img src={ company.small_logo === "" ? tuLogoAqui : URL_API_UPLOADS + smallLogo } alt="Erp-Iw-Logo-Small" width="100" style={{paddingTop: '6px', width: '100px', height: '32px' }}/>
                : <img src={theme.palette.mode === 'dark' ? logoDark : logo} alt="Erp-Iw-Logo-Small" width="100" style={{paddingTop: '6px'}}/>
            }
        </div>
    );
};

export default LogoAdminFarPro;
